import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'

import _findIndex from 'lodash/findIndex'
import _clone from 'lodash/clone'
import _isUndefined from 'lodash/isUndefined'

const dynamicPaths = require('../dynamicPaths.js')

export default new Vuex.Store({
  state: {
    menus : [],
    locations : [],
    menuBoard : null,
    wpData : {},
    authToken : false,
    hideGlobalUI : true,
    menuLoaded : 0,
    wpapi : null,
    puppeteerReady : false,
    publicPath : dynamicPaths.publicPath,
    fontSize : null
  },
  mutations:{
    setMenus(state, menus) {
      state.menus = menus;
    },

    addMenu(state) {
      let newMenu = {
        id : Date.now(),
        new : true,
        title: {rendered : 'Menu ' + (this.state.menus.length + 1) },
        editable:true,
        menu_order : this.state.menus.length,
        acf : {sections : []}
      };

      state.menus.push(newMenu);  
    },

    removeMenu(state, menu_id) {
      state.menus = state.menus.filter(menu=> menu.id !== menu_id )
    },

    refreshMenu(state, menu ) {
      let menu_id = menu.id;

      // then splicing the wpMenus obj
      let index = _findIndex(state.menus, function(menu) { return menu.id == menu_id });
      let tmpMenu = _clone(state.menus[ index ]);
      tmpMenu.title = menu.title;
      tmpMenu.acf = menu.acf;
      state.menus.splice( index, 1, tmpMenu );
      
    }, 

    setLocations(state, locations) {
      state.locations = locations;
    },

    setLocationAcf(state, {acfObj, loc_id}) {
      let index = _findIndex(state.locations, loc => { return loc.id == loc_id });
      let tmpLoc = _clone(state.locations[ index ]);
      tmpLoc.acf = acfObj;
      state.locations.splice( index, 1, tmpLoc );
    }, // setLocationAcf()

    setMenuBoard(state, menuBoard) {
      state.menuBoard = menuBoard;
    },

    setWpData(state, wpData) {
      state.wpData = wpData;
    },
    setAuthToken(state, token) {
      state.authToken = token;
    },

    toggleUI(state) {
      state.hideGlobalUI = !state.hideGlobalUI;
    }, // toggleUI

    SET_WPAPI(state, api) {
      state.wpapi = api;
    }, // SET_WPAPI

    setPuppeteerReady(state) {
      state.puppeteerReady = 1;
    },
    
    UPDATE_MENU_FONT_SIZE(state, fontSize){
      state.fontSize = fontSize
    }, // UPDATE_MENU_FONT_SIZE

  },
  actions:{
    authPromise({state,commit}, payload) {

      if( _isUndefined( payload ) || _isUndefined( payload.username ) || _isUndefined(payload.password)  ) {
        return false;
      }

      if( state.authToken ) {
        return new Promise((resolve, reject) => {
          resolve( state.authToken );
        })
      }

      return axios.post(`${state.wpData.rest_url}/jwt-auth/v1/token`,
          { username:payload.username, password:payload.password }
      )
      .then( authRes => {
        let authToken = authRes.data.token;
        commit('setAuthToken', authToken);
        return authToken; // this allows chaining with .then() 
      })
      .catch( err => {
        return err;
      })
    },
    buildSingleMenuPromises(state, menu) {
      
    }
  },
  getters:{
    getMenuById: ( state ) => ( menu_uuid ) => {
      return state.menus.find( menu => menu.menu_uuid === menu_uuid )

    },
    getSectionById : ( state, getters ) => ( menu_uuid, section_uuid ) => {
      return getters.getMenuById( menu_uuid )
              .acf.sections.find( section => section.section_uuid === section_uuid )
    },
    wpData( state ) {
      return state.wpData;
    },
    isAuthenticated(state) {
      return "undefined" !== typeof state.authToken && !!state.wpData.user.logged_in;
    }
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js